import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NoraChatStatisticsResponse } from '../models/nora-statistics.models';
import { ChatMessage } from '../models/chat.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NoraChatStatisticsService {
  private apiUrl: string;

  constructor(private http: HttpClient) {
    this.apiUrl = environment.apiUrl + '/chat';
  }

  getStatistics(
    page: number,
    pageSize: number,
    userFilter?: string,
    dateFrom?: string,
    dateTo?: string
  ): Observable<NoraChatStatisticsResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (userFilter) {
      params = params.set('userFilter', userFilter);
    }
    if (dateFrom) {
      params = params.set('dateFrom', dateFrom);
    }
    if (dateTo) {
      params = params.set('dateTo', dateTo);
    }

    return this.http.get<NoraChatStatisticsResponse>(`${this.apiUrl}/statistics`, { params });
  }

  getSessionMessages(sessionId: string): Observable<ChatMessage[]> {
    return this.http.get<ChatMessage[]>(`${this.apiUrl}/sessions/${sessionId}/messages`);
  }
}
